import { render, staticRenderFns } from "./privacy-policy.vue?vue&type=template&id=c7350f08"
import script from "./privacy-policy.js?vue&type=script&lang=js&external"
export * from "./privacy-policy.js?vue&type=script&lang=js&external"
import style0 from "./privacy-policy.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports